import { cn } from '@skupreme/shared/ui';
import type { ComponentPropsWithoutRef } from 'react';

type DivProps = ComponentPropsWithoutRef<'div'>;

export function Suffix({ className, ...props }: DivProps) {
  return (
    <div
      className={cn(
        'sk:-ml-px sk:flex sk:h-10 sk:items-center sk:rounded-r-md',
        className,
      )}
      {...props}
    />
  );
}

export function Velocities({ className, ...props }: DivProps) {
  return (
    <div
      className={cn(
        'sk:flex sk:flex-wrap sk:items-start sk:gap-2.5',
        className,
      )}
      {...props}
    />
  );
}

export function LeftIcon({ icon_type, color }) {
  if (icon_type === types.warehouse) {
    return (
      <div style={{ paddingTop: '2px' }}>
        <StorageIcon color={color} />
      </div>
    );
  }
  if (icon_type === types.truck) {
    return (
      <div style={{ paddingTop: '2px' }}>
        <VanIcon color={color} />
      </div>
    );
  }
  return (
    <svg height={13} width={10}>
      <g transform={`translate(${5},${10})`}>
        <circle cy={-4} fill={color} r={5} />
      </g>
    </svg>
  );
}

export const types = {
  shipment: 'shipment',
  provider: 'provider',
  warehouse: 'warehouse',
  truck: 'truck',
};

function StorageIcon({ color }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.904097 4.29498C0.657066 4.45461 0.508301 4.72582 0.508301 5.01657V14.1173C0.508301 14.5941 0.901225 14.9806 1.38592 14.9806H2.14116C2.69344 14.9806 3.14116 14.5329 3.14116 13.9806V7.64227C3.14116 7.16546 3.53408 6.77893 4.01878 6.77893H11.4785C11.9632 6.77893 12.3562 7.16546 12.3562 7.64227V13.9806C12.3562 14.5329 12.8039 14.9806 13.3562 14.9806H14.1114C14.5961 14.9806 14.989 14.5941 14.989 14.1173V5.01657C14.989 4.72583 14.8403 4.45461 14.5932 4.29498L8.23049 0.641746C7.938 0.452751 7.55933 0.452751 7.26684 0.641747L0.904097 4.29498Z"
        fill={color}
      />
      <rect
        x="8.40796"
        y="11.959"
        width="3.07167"
        height="3.02167"
        rx="1.51083"
        fill={color}
      />
      <rect
        x="8.40796"
        y="11.959"
        width="3.07167"
        height="3.02167"
        rx="1"
        fill={color}
      />
      <rect
        x="4.89526"
        y="11.959"
        width="3.07167"
        height="3.02167"
        rx="1"
        fill={color}
      />
      <rect
        x="8.40796"
        y="8.50586"
        width="3.07167"
        height="3.02167"
        rx="1"
        fill={color}
      />
    </svg>
  );
}

function VanIcon({ color }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 6C9 5.44772 9.44772 5 10 5H11.5858C11.851 5 12.1054 5.10536 12.2929 5.29289L14.7071 7.70711C14.8946 7.89464 15 8.149 15 8.41421V10C15 10.5523 14.5523 11 14 11H10C9.44772 11 9 10.5523 9 10V6Z"
        fill={color}
      />
      <path
        d="M0 4C0 3.44772 0.447715 3 1 3H7C7.55229 3 8 3.44772 8 4V10C8 10.5523 7.55229 11 7 11H1C0.447715 11 0 10.5523 0 10V4Z"
        fill={color}
      />
      <circle cx="3" cy="11" r="1.5" fill={color} />
      <circle cx="11.5" cy="11" r="1.5" fill={color} />
    </svg>
  );
}
